import { useState } from 'react';

/* ── CONSTANTS ── */
const WHATSAPP_NUMBER = '919766624663';

// Utility: format number with Indian comma style (1,00,000)
const toIndianFormat = (val: string) => {
  const digits = val.replace(/[^0-9]/g, '');
  if (!digits) return '';
  return Number(digits).toLocaleString('en-IN');
};



const BRAND_MODELS: Record<string, string[]> = {
  'Maruti Suzuki': [
    'Alto', 'Alto K10', 'S-Presso', 'Celerio', 'WagonR', 'Swift', 'Baleno',
    'Dzire', 'Ignis', 'Fronx', 'Brezza', 'Grand Vitara', 'XL6', 'Ertiga',
    'Invicto', 'Jimny', 'Ciaz', 'Eeco', 'Omni',
  ],
  'Hyundai': [
    'Santro', 'Grand i10 Nios', 'i20', 'i20 N Line', 'Aura', 'Verna',
    'Exter', 'Venue', 'Venue N Line', 'Creta', 'Creta N Line', 'Alcazar',
    'Tucson', 'Ioniq 5', 'Kona Electric',
  ],
  'Tata': [
    'Tiago', 'Tiago EV', 'Tigor', 'Tigor EV', 'Altroz', 'Punch', 'Punch EV',
    'Nexon', 'Nexon EV', 'Harrier', 'Safari', 'Curvv', 'Curvv EV', 'Sierra',
  ],
  'Mahindra': [
    'Bolero', 'Bolero Neo', 'Bolero Neo+', 'Scorpio', 'Scorpio-N', 'Scorpio Classic',
    'XUV300', 'XUV 3XO', 'XUV400 EV', 'XUV700', 'Thar', 'Thar Roxx',
    'BE 6', 'XEV 9e', 'Marazzo', 'TUV300',
  ],
  'Honda': [
    'Amaze', 'City', 'City Hybrid', 'City e:HEV', 'Elevate', 'Jazz', 'WR-V',
  ],
  'Toyota': [
    'Glanza', 'Urban Cruiser Hyryder', 'Innova Crysta', 'Innova HyCross',
    'Fortuner', 'Fortuner Legender', 'Hilux', 'Vellfire', 'Camry', 'Rumion', 'Land Cruiser',
  ],
  'Kia': ['Sonet', 'Sonet X-Line', 'Seltos', 'Seltos X-Line', 'Carens', 'EV6', 'EV9'],
  'Renault': ['Kwid', 'Triber', 'Kiger'],
  'Volkswagen': ['Polo', 'Vento', 'Taigun', 'Virtus'],
  'Skoda': ['Kushaq', 'Slavia', 'Kodiaq', 'Superb', 'Octavia'],
  'Ford': ['Figo', 'Aspire', 'EcoSport', 'Endeavour', 'Freestyle', 'Mustang', 'Mustang Mach-E'],
  'MG': ['Hector', 'Hector Plus', 'Astor', 'ZS EV', 'Comet EV', 'Gloster', 'Windsor EV'],
  'Jeep': ['Compass', 'Meridian', 'Wrangler', 'Grand Cherokee'],
  'BMW': [
    '1 Series', '2 Series Gran Coupe', '3 Series', '3 Series Gran Limousine',
    '5 Series', '6 Series GT', '7 Series', 'X1', 'X3', 'X5', 'X7',
    'XM', 'Z4', 'iX', 'iX1', 'iX3', 'i4', 'i5', 'i7', 'M3', 'M4', 'M5', 'M8',
  ],
  'Mercedes-Benz': [
    'A-Class', 'A-Class Limousine', 'B-Class', 'C-Class', 'E-Class', 'S-Class',
    'CLA', 'CLS', 'GLA', 'GLB', 'GLC', 'GLE', 'GLS', 'G-Class',
    'AMG GT', 'EQA', 'EQB', 'EQC', 'EQE', 'EQS',
  ],
  'Audi': [
    'A3', 'A4', 'A6', 'A7', 'A8', 'Q3', 'Q3 Sportback', 'Q5', 'Q7', 'Q8',
    'Q8 e-tron', 'e-tron GT', 'RS3', 'RS5', 'RS6', 'RS7', 'R8', 'TT',
  ],
  'Volvo': ['S60', 'S90', 'V90 Cross Country', 'XC40', 'XC40 Recharge', 'XC60', 'XC90', 'C40 Recharge'],
  'Jaguar': ['XE', 'XF', 'XJ', 'F-Type', 'E-Pace', 'F-Pace', 'I-Pace'],
  'Land Rover': [
    'Defender 90', 'Defender 110', 'Discovery', 'Discovery Sport',
    'Range Rover', 'Range Rover Sport', 'Range Rover Velar', 'Range Rover Evoque',
  ],
  'Nissan': ['Magnite', 'Kicks', 'GT-R', 'Leaf'],
  'Mitsubishi': ['Outlander', 'Eclipse Cross', 'Pajero Sport'],
  'Fiat': ['Punto', 'Linea', 'Abarth 595', 'Abarth Punto'],
  'Porsche': ['Cayenne', 'Macan', 'Panamera', '911', '718 Cayman', '718 Boxster', 'Taycan'],
  'Lexus': ['ES', 'LS', 'NX', 'RX', 'UX', 'LC', 'LX', 'RZ'],
  'Other': [],
};

const CAR_BRANDS = Object.keys(BRAND_MODELS);
const FUEL_TYPES = ['Petrol', 'Diesel', 'CNG', 'Electric', 'Hybrid', 'LPG'];
const TRANSMISSION_TYPES = ['Manual', 'Automatic', 'AMT', 'DCT', 'CVT'];
const OWNERSHIP_TYPES = ['First Owner', 'Second Owner', 'Third Owner', 'Fourth Owner'];
const MH_STATES = [
  'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat',
  'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Telangana', 'Andhra Pradesh',
  'Kerala', 'Punjab', 'Haryana', 'Madhya Pradesh', 'Goa', 'Other',
];
const CURRENT_YEAR = new Date().getFullYear();
const YEARS = Array.from({ length: 25 }, (_, i) => String(CURRENT_YEAR - i));

/* ── TYPES ── */
interface FormState {
  name: string;
  phone: string;
  brand: string;
  model: string;
  variant: string;
  year: string;
  fuel: string;
  transmission: string;
  ownership: string;
  kms: string;
  insurance_valid: boolean;
  city: string;
  state: string;
  expected_price: string;
  extra_notes: string;
}

const EMPTY_FORM: FormState = {
  name: '', phone: '', brand: '', model: '', variant: '', year: '',
  fuel: 'Petrol', transmission: 'Manual', ownership: 'First Owner',
  kms: '', insurance_valid: false , city: '', state: 'Maharashtra',
  expected_price: '', extra_notes: '',
};

/* ══════════════════════════════════════════
   MAIN COMPONENT
══════════════════════════════════════════ */
export default function SellYourCar() {
  const [form, setForm] = useState<FormState>(EMPTY_FORM);
  const [errors, setErrors] = useState<Partial<FormState>>({});
  const [submitted, setSubmitted] = useState(false);

  const f = (key: keyof FormState, value: string | boolean) => {
    setForm(prev => ({ ...prev, [key]: value }));
    if (errors[key]) setErrors(prev => ({ ...prev, [key]: '' }));
  };


  const handleBrandChange = (brand: string) => {
    setForm(prev => ({ ...prev, brand, model: '', variant: '' }));
    if (errors.brand) setErrors(prev => ({ ...prev, brand: '' }));
    if (errors.model) setErrors(prev => ({ ...prev, model: '' }));
  };

  const handleModelChange = (model: string) => {
    setForm(prev => ({ ...prev, model, variant: '' }));
    if (errors.model) setErrors(prev => ({ ...prev, model: '' }));
  };

  const availableModels = form.brand ? BRAND_MODELS[form.brand] ?? [] : [];
  const isOtherBrand = form.brand === 'Other' || availableModels.length === 0;

  const validate = (): boolean => {
    const newErrors: Partial<FormState> = {};
    if (!form.name.trim())  newErrors.name  = 'Name is required';
    if (!form.phone.trim()) newErrors.phone = 'Phone is required';
    else if (!/^\d{10}$/.test(form.phone.trim())) newErrors.phone = 'Enter valid 10-digit number';
    if (!form.brand)        newErrors.brand = 'Select a brand';
    if (!form.model.trim()) newErrors.model = 'Model is required';
    if (!form.year)         newErrors.year  = 'Select year';
    if (!form.city.trim())  newErrors.city  = 'City is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleEnquire = () => {
    if (!validate()) return;
    const msg = [
      `🚗 *New Car Sell Enquiry — PRG Cars*`,
      ``,
      `*Owner Details*`,
      `👤 Name: ${form.name}`,
      `📞 Phone: +91 ${form.phone}`,
      ``,
      `*Car Details*`,
      `🏷️ Brand: ${form.brand}`,
      `🚘 Model: ${form.model}`,
      form.variant ? `🔖 Variant: ${form.variant}` : '',
      `📅 Year: ${form.year}`,
      `⛽ Fuel: ${form.fuel}`,
      `⚙️ Transmission: ${form.transmission}`,
      `🔑 Ownership: ${form.ownership}`,
      form.kms ? `📍 KMs Driven: ${(form.kms)} km` : '',
      form.insurance_valid ? `🛡️ Insurance Valid Till: ${form.insurance_valid}` : '',
      ``,
      `*Location*`,
      `🏙️ City: ${form.city}, ${form.state}`,
      ``,
      form.expected_price ? `💰 Expected Price: ₹ ${Number(form.expected_price.replace(/,/g, '')).toLocaleString('en-IN')}` : '',
      form.extra_notes ? `📝 Notes: ${form.extra_notes}` : '',
    ].filter(Boolean).join('\n');

    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`, '_blank');
    setSubmitted(true);
  };

  const handleReset = () => { setForm(EMPTY_FORM); setErrors({}); setSubmitted(false); };

  return (
    <>
      <style>{styles}</style>
      <div className="syc-page">

        {/* ── HERO ── */}
        <div className="syc-hero">
          <div className="hero-glow" />
          <div className="hero-pattern" />
          <div className="hero-content">
            <div className="hero-badge">SELL YOUR CAR</div>
            <h1 className="hero-title">Get the Best Price<br />for Your Car</h1>
            <p className="hero-sub">
              Fill in your car details and we'll connect you instantly.<br />
              Quick evaluation.
            </p>
            <div className="hero-trust">
              {['💯 Best Price', '🔒 Safe & Secure'].map(t => (
                <span key={t} className="trust-chip">{t}</span>
              ))}
            </div>
          </div>
        </div>

        <div className="syc-container">
          {submitted ? (
            <div className="success-card">
              <div className="success-icon">✓</div>
              <h2 className="success-title">WhatsApp Opened!</h2>
              <p className="success-sub">
                Your enquiry is pre-filled on WhatsApp. Just hit send and our team will get back to you shortly.
              </p>
              <button className="success-btn" onClick={handleReset}>Submit Another Car</button>
            </div>
          ) : (
            <div className="form-card">

              <Section label="Your Details">
                <div className="two-col">
                  <Field label="Full Name *" error={errors.name}>
                    <input className={`syc-inp ${errors.name ? 'inp-err' : ''}`}
                      value={form.name} onChange={e => f('name', e.target.value)}
                      placeholder="Rahul Sharma" />
                  </Field>
                  <Field label="Phone Number *" error={errors.phone}>
                    <div className="phone-wrap">
                      <span className="phone-prefix">+91</span>
                      <input className={`syc-inp phone-inp ${errors.phone ? 'inp-err' : ''}`}
                        value={form.phone}
                        onChange={e => f('phone', e.target.value.replace(/\D/g, '').slice(0, 10))}
                        placeholder="9876543210" inputMode="numeric" />
                    </div>
                  </Field>
                </div>
              </Section>

              <Section label="Car Details">
                {/* Row 1: Brand + Model */}
                <div className="two-col">
                  <Field label="Brand *" error={errors.brand}>
                    <select className={`syc-inp ${errors.brand ? 'inp-err' : ''}`}
                      value={form.brand} onChange={e => handleBrandChange(e.target.value)}>
                      <option value="">Select Brand</option>
                      {CAR_BRANDS.map(b => <option key={b}>{b}</option>)}
                    </select>
                  </Field>
                  <Field label="Model *" error={errors.model}>
                    {!form.brand ? (
                      <input className="syc-inp" disabled placeholder="Select a brand first"
                        style={{ opacity: 0.45, cursor: 'not-allowed' }} />
                    ) : isOtherBrand ? (
                      <input className={`syc-inp ${errors.model ? 'inp-err' : ''}`}
                        value={form.model} onChange={e => handleModelChange(e.target.value)}
                        placeholder="Enter model name" />
                    ) : (
                      <select className={`syc-inp ${errors.model ? 'inp-err' : ''}`}
                        value={form.model} onChange={e => handleModelChange(e.target.value)}>
                        <option value="">Select Model</option>
                        {availableModels.map(m => <option key={m}>{m}</option>)}
                      </select>
                    )}
                  </Field>
                </div>

                {/* Row 2: Variant (full width) */}
                <Field label="Variant">
                  <input
                    className="syc-inp"
                    value={form.variant}
                    onChange={e => f('variant', e.target.value)}
                    placeholder={
                      !form.model
                        ? 'Select a model first'
                        : 'e.g. VXI, ZXI, VTi, S, Sportz, Titanium...'
                    }
                    disabled={!form.model}
                    style={!form.model ? { opacity: 0.45, cursor: 'not-allowed' } : {}}
                  />
                  {form.model && (
                    <span className="field-hint">
                      Optional — helps us give a more accurate valuation
                    </span>
                  )}
                </Field>

                {/* Row 3: Year + Fuel */}
                <div className="two-col">
                  <Field label="Year *" error={errors.year}>
                    <select className={`syc-inp ${errors.year ? 'inp-err' : ''}`}
                      value={form.year} onChange={e => f('year', e.target.value)}>
                      <option value="">Select Year</option>
                      {YEARS.map(y => <option key={y}>{y}</option>)}
                    </select>
                  </Field>
                  <Field label="Fuel Type">
                    <select className="syc-inp" value={form.fuel} onChange={e => f('fuel', e.target.value)}>
                      {FUEL_TYPES.map(ft => <option key={ft}>{ft}</option>)}
                    </select>
                  </Field>
                </div>

                {/* Row 4: Transmission + Ownership */}
                <div className="two-col">
                  <Field label="Transmission">
                    <select className="syc-inp" value={form.transmission} onChange={e => f('transmission', e.target.value)}>
                      {TRANSMISSION_TYPES.map(t => <option key={t}>{t}</option>)}
                    </select>
                  </Field>
                  <Field label="Ownership">
                    <select className="syc-inp" value={form.ownership} onChange={e => f('ownership', e.target.value)}>
                      {OWNERSHIP_TYPES.map(o => <option key={o}>{o}</option>)}
                    </select>
                  </Field>
                </div>

                {/* Row 5: KMs + Insurance */}
                <div className="two-col">
                  <Field label="KMs Driven">
                  <input
                    className="syc-inp"
                    value={form.kms}
                    onChange={e => f('kms', toIndianFormat(e.target.value))}
                    placeholder="e.g. 45,000"
                    inputMode="numeric"
                  />
                  </Field>
                  <Field label="Insurance">
                    <label className="checkbox-wrap">
                      <input
                        type="checkbox"
                        className="syc-checkbox"
                        checked={form.insurance_valid}
                        onChange={e => f('insurance_valid', e.target.checked as any)}
                      />
                      <span className="checkbox-box">
                        {form.insurance_valid && (
                          <svg width="11" height="9" viewBox="0 0 11 9" fill="none">
                            <path d="M1 4L4 7.5L10 1" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        )}
                      </span>
                      <span className="checkbox-label">
                        Insurance is currently valid
                      </span>
                    </label>
                  </Field>
                </div>
              </Section>

              <Section label="Location">
                <div className="two-col">
                  <Field label="City *" error={errors.city}>
                    <input className={`syc-inp ${errors.city ? 'inp-err' : ''}`}
                      value={form.city} onChange={e => f('city', e.target.value)}
                      placeholder="e.g. Nagpur" />
                  </Field>
                  <Field label="State">
                    <select className="syc-inp" value={form.state} onChange={e => f('state', e.target.value)}>
                      {MH_STATES.map(s => <option key={s}>{s}</option>)}
                    </select>
                  </Field>
                </div>
              </Section>

              <Section label="Pricing & Notes">
                <div className="two-col">
                  <Field label="Expected Price (₹)">
                  <input
                    className="syc-inp"
                    value={form.expected_price}
                    onChange={e => f('expected_price', toIndianFormat(e.target.value))}
                    placeholder="e.g. 5,00,000"
                    inputMode="numeric"
                  />
                  </Field>
                  <Field label="Additional Notes">
                    <input className="syc-inp" value={form.extra_notes}
                      onChange={e => f('extra_notes', e.target.value)}
                      placeholder="Sunroof, new tyres, accident-free..." />
                  </Field>
                </div>
              </Section>

              <div className="submit-area">
                <p className="submit-note">
                  Clicking below opens WhatsApp with your car details pre-filled — just hit send!
                </p>
                <button className="enquire-btn" onClick={handleEnquire}>
                  <span className="wa-icon">
                    <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </span>
                  Submit Details on WhatsApp
                </button>
              </div>

            </div>
          )}

          {/* ── HOW IT WORKS — redesigned ── */}
          <div className="how-it-works">
            <div className="hiw-header">
              <div className="hiw-badge">SIMPLE PROCESS</div>
              <h3 className="hiw-title">Sell your car in 3 easy steps</h3>
              <p className="hiw-sub">From form to payment — the whole process takes less than 24 hours</p>
            </div>
            <div className="hiw-steps">
            {[
  {
    num: '01',
    label: 'Fill the Form',
    desc: 'Enter your car details and contact info above. Takes less than 2 minutes.',
    color: '#C8A800',
    svg: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <rect x="6" y="4" width="24" height="28" rx="3" stroke="#C8A800" strokeWidth="1.8"/>
        <path d="M11 12h14M11 17h14M11 22h8" stroke="#C8A800" strokeWidth="1.8" strokeLinecap="round"/>
        <circle cx="26" cy="27" r="5" fill="#C8A800"/>
        <path d="M23.5 27l1.5 1.5 3-3" stroke="#fff" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    num: '02',
    label: 'Send on WhatsApp',
    desc: 'Hit the green button — your details open pre-filled in WhatsApp. Just press send.',
    color: '#25D366',
    svg: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <circle cx="18" cy="18" r="13" stroke="#25D366" strokeWidth="1.8"/>
        <path d="M23.5 14.5c-1.5-1.5-3.5-2.5-5.5-2.5-4.4 0-8 3.6-8 8 0 1.4.4 2.8 1 4L10 30l5.5-1.5c1.1.6 2.3.9 3.5.9 4.4 0 8-3.6 8-8 0-2-.8-4-2.5-5.5-.5-.5 0 0 0 0z" stroke="#25D366" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M15 18c.5 1 1.5 2 2.5 2.5" stroke="#25D366" strokeWidth="1.8" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    num: '03',
    label: 'Get Paid',
    desc: 'Accept our best-price offer and receive instant bank transfer.',
    color: '#2ECC71',
    svg: (
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
        <rect x="5" y="10" width="26" height="18" rx="3" stroke="#2ECC71" strokeWidth="1.8"/>
        <path d="M5 15h26" stroke="#2ECC71" strokeWidth="1.8"/>
        <circle cx="18" cy="23" r="3.5" stroke="#2ECC71" strokeWidth="1.8"/>
        <path d="M10 23h2M24 23h2" stroke="#2ECC71" strokeWidth="1.8" strokeLinecap="round"/>
        <path d="M17 6l1 2 1-2" stroke="#2ECC71" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
        ),
      },
          ].map((s, i, arr) => (
            <div key={s.num} className="hiw-step">
              <div className="hiw-step-icon" style={{ background: `${s.color}18`, border: `1.5px solid ${s.color}33` }}>
                {s.svg}
              </div>
              {i < arr.length - 1 && <div className="hiw-connector" />}
              <div className="hiw-num" style={{ color: s.color }}>{s.num}</div>
              <div className="hiw-label">{s.label}</div>
              <div className="hiw-desc">{s.desc}</div>
            </div>
          ))}
            </div>
            <div className="hiw-footer">
              <span className="hiw-footer-item">*conditions apply</span>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

/* ── SUB-COMPONENTS ── */
function Section({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="form-section">
      <div className="section-label">{label}</div>
      <div className="section-body">{children}</div>
    </div>
  );
}

function Field({ label, children, error }: { label: string; children: React.ReactNode; error?: string }) {
  return (
    <div className="field-group">
      <label className="field-label">{label}</label>
      {children}
      {error && <span className="field-err">{error}</span>}
    </div>
  );
}

/* ── STYLES ── */


const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .syc-page {
    background: #F5F4F0;
    min-height: 100vh;
    color: #111;
    font-family: 'Segoe UI', system-ui, sans-serif;
  }

  .syc-hero {
    position: relative; background: #111;
    padding: 72px 20px 60px; text-align: center; overflow: hidden;
  }
  .hero-glow {
    position: absolute; inset: 0;
    background: radial-gradient(ellipse 65% 70% at 50% 100%, rgba(255,215,0,0.13) 0%, transparent 65%);
    pointer-events: none;
  }
  .hero-pattern {
    position: absolute; inset: 0;
    background-image: radial-gradient(circle, rgba(255,255,255,0.03) 1px, transparent 1px);
    background-size: 28px 28px; pointer-events: none;
  }
  .hero-content { position: relative; z-index: 1; }
  .hero-badge {
    display: inline-block;
    background: rgba(255,215,0,0.1); border: 1px solid rgba(255,215,0,0.25);
    color: #FFD700; font-size: 11px; font-weight: 700;
    letter-spacing: 0.16em; padding: 5px 16px; border-radius: 20px; margin-bottom: 22px;
  }
  .hero-title {
    font-size: clamp(28px, 5vw, 48px); font-weight: 800; color: #fff;
    line-height: 1.12; margin-bottom: 18px; letter-spacing: -0.025em;
  }
  .hero-sub { font-size: 15px; color: #777; line-height: 1.75; max-width: 460px; margin: 0 auto 28px; }
  .hero-trust { display: flex; gap: 10px; justify-content: center; flex-wrap: wrap; }
  .trust-chip {
    background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.1);
    color: #999; font-size: 12px; font-weight: 500; padding: 6px 16px; border-radius: 20px;
  }

  .syc-container { max-width: 720px; margin: 0 auto; padding: 36px 16px 64px; }

  .form-card {
    background: #fff; border: 1px solid #E5E3DC; border-radius: 18px;
    overflow: hidden; margin-bottom: 24px;
    box-shadow: 0 2px 24px rgba(0,0,0,0.06), 0 1px 4px rgba(0,0,0,0.04);
  }

  .form-section { padding: 26px 28px; border-bottom: 1px solid #F0EEE8; }
  .form-section:last-child { border-bottom: none; }
  .section-label {
    font-size: 10px; font-weight: 700; color: #B8AF94;
    letter-spacing: 0.14em; text-transform: uppercase;
    margin-bottom: 18px; padding-bottom: 12px; border-bottom: 1px solid #F0EEE8;
  }
  .section-body { display: flex; flex-direction: column; gap: 14px; }

  .two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }

  .field-group { display: flex; flex-direction: column; gap: 6px; }
  .field-label { font-size: 12px; font-weight: 600; color: #888; letter-spacing: 0.01em; }
  .field-err { font-size: 11px; color: #D63B3B; margin-top: 2px; }
  .field-hint { font-size: 11px; color: #B8AF94; margin-top: 3px; font-style: italic; }

  .syc-inp {
    width: 100%; background: #FAFAF7; border: 1.5px solid #E5E3DC;
    border-radius: 10px; color: #1a1a1a; padding: 11px 14px; font-size: 14px;
    outline: none; transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    -webkit-appearance: none; appearance: none; font-family: inherit;
  }
  .syc-inp:focus {
    border-color: #C8A800; box-shadow: 0 0 0 3px rgba(212,176,0,0.12); background: #fff;
  }
  .syc-inp::placeholder { color: #C5C0AE; }
  select.syc-inp {
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='7' viewBox='0 0 11 7'%3E%3Cpath d='M1 1l4.5 4.5L10 1' stroke='%23AAA' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat; background-position: right 14px center; padding-right: 36px;
  }
  select.syc-inp option { background: #fff; color: #1a1a1a; }
  .inp-err { border-color: #D63B3B !important; box-shadow: 0 0 0 3px rgba(214,59,59,0.08) !important; }

  .phone-wrap { display: flex; align-items: stretch; }
  .phone-prefix {
    background: #F2F0EA; border: 1.5px solid #E5E3DC; border-right: none;
    border-radius: 10px 0 0 10px; padding: 11px 13px; font-size: 14px; color: #999;
    white-space: nowrap; display: flex; align-items: center; font-family: inherit;
  }
  .phone-inp { border-radius: 0 10px 10px 0 !important; flex: 1; }

  .submit-area {
    padding: 24px 28px 28px; background: #FAFAF7; border-top: 1.5px solid #F0EEE8;
    display: flex; flex-direction: column; align-items: center; gap: 14px;
  }
  .submit-note { font-size: 12px; color: #AAA499; text-align: center; max-width: 380px; line-height: 1.65; }
  .enquire-btn {
    display: flex; align-items: center; gap: 10px; justify-content: center;
    width: 100%; max-width: 340px; background: #25D366; color: #fff;
    border: none; border-radius: 12px; padding: 15px 24px;
    font-size: 16px; font-weight: 700; cursor: pointer; font-family: inherit;
    transition: opacity 0.15s, transform 0.1s, box-shadow 0.15s;
    box-shadow: 0 4px 18px rgba(37,211,102,0.3); letter-spacing: 0.01em;
  }
  .enquire-btn:hover { opacity: 0.92; transform: translateY(-1px); box-shadow: 0 7px 22px rgba(37,211,102,0.38); }
  .enquire-btn:active { transform: translateY(0); }
  .wa-icon { display: flex; align-items: center; }

  .success-card {
    background: #fff; border: 1px solid #E5E3DC; border-radius: 18px;
    padding: 56px 28px; text-align: center; margin-bottom: 24px;
    box-shadow: 0 2px 24px rgba(0,0,0,0.06);
  }
  .success-icon {
    width: 68px; height: 68px; border-radius: 50%;
    background: rgba(37,211,102,0.1); border: 2px solid rgba(37,211,102,0.25);
    display: flex; align-items: center; justify-content: center;
    font-size: 30px; color: #25D366; margin: 0 auto 22px;
  }
  .success-title { font-size: 24px; font-weight: 800; color: #111; margin-bottom: 10px; }
  .success-sub { font-size: 14px; color: #888; line-height: 1.75; max-width: 340px; margin: 0 auto 28px; }
  .success-btn {
    background: #fff; border: 1.5px solid #E5E3DC; color: #666; border-radius: 10px;
    padding: 12px 28px; font-size: 14px; font-weight: 600; cursor: pointer; font-family: inherit;
    transition: border-color 0.15s, color 0.15s;
  }
  .success-btn:hover { border-color: #C8A800; color: #8A6E00; }

  /* ── HOW IT WORKS — redesigned ── */
  .how-it-works {
    background: #fff; border: 1px solid #E5E3DC; border-radius: 18px;
    padding: 36px 28px 28px; box-shadow: 0 1px 8px rgba(0,0,0,0.04);
  }
  .hiw-header { text-align: center; margin-bottom: 36px; }
  .hiw-badge {
    display: inline-block;
    background: rgba(200,168,0,0.08); border: 1px solid rgba(200,168,0,0.2);
    color: #C8A800; font-size: 10px; font-weight: 700;
    letter-spacing: 0.14em; padding: 4px 14px; border-radius: 20px; margin-bottom: 12px;
  }
  .hiw-title { font-size: 20px; font-weight: 800; color: #111; margin-bottom: 8px; letter-spacing: -0.02em; }
  .hiw-sub { font-size: 13px; color: #999; line-height: 1.6; }

  .hiw-steps {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }
  .hiw-step {
    display: flex; flex-direction: column; align-items: center;
    text-align: center; padding: 0 8px; position: relative;
    margin:5px;
  }
  .hiw-step-icon {
    width: 56px; height: 56px; border-radius: 16px;
    display: flex; align-items: center; justify-content: center;
    margin-bottom: 12px; position: relative; z-index: 1;
    transition: transform 0.2s;
  }
  .hiw-step:hover .hiw-step-icon { transform: translateY(-3px); }
  .hiw-emoji { font-size: 24px; line-height: 1; }

  /* connector line between steps */
  .hiw-connector {
    position: absolute;
    top: 28px;
    left: calc(50% + 28px);
    width: calc(100% - 56px);
    height: 1.5px;
    background: linear-gradient(90deg, #E5E3DC, #E5E3DC);
    z-index: 0;
  }

  .hiw-num { font-size: 11px; font-weight: 800; letter-spacing: 0.06em; margin-bottom: 6px; }
  .hiw-label { font-size: 13px; font-weight: 700; color: #222; margin-bottom: 6px; }
  .hiw-desc { font-size: 1rem; color: #999; line-height: 1.6; font-style:italic}

  .hiw-footer {
    display: flex; align-items: center; justify-content: center;
    gap: 10px; flex-wrap: wrap;
    margin-top: 28px; padding-top: 20px;
    border-top: 1px solid #F0EEE8;
  }
  .hiw-footer-item { font-size: 12px; font-weight: 600; color: #66666682; }
  .hiw-divider { color: #DDD9CE; font-size: 14px; }

  ::-webkit-scrollbar { width: 5px; height: 5px; }
  ::-webkit-scrollbar-track { background: #F5F4F0; }
  ::-webkit-scrollbar-thumb { background: #DDD9CE; border-radius: 4px; }

  @media (max-width: 640px) {
    .syc-hero { padding: 52px 16px 44px; }
    .hero-title { font-size: 27px; }
    .hero-sub { font-size: 14px; }
    .two-col { grid-template-columns: 1fr; }
    .form-section { padding: 20px 18px; }
    .submit-area { padding: 20px 18px 24px; }
    .enquire-btn { font-size: 15px; padding: 14px 20px; }

    .how-it-works { padding: 28px 18px 22px; }
    .hiw-title { font-size: 18px; }
    .hiw-steps { grid-template-columns: repeat(2, 1fr); gap: 16px; }
    .hiw-connector { display: none; }
    .hiw-step { padding: 16px 12px; background: #FAFAF7; border-radius: 14px; border: 1px solid #EEEAE0; }
  }

  .hiw-step 
  { 
    padding: 16px 12px; background: #FAFAF7; border-radius: 14px; border: 1px solid #EEEAE0; 
  }
}
  .checkbox-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    padding: 11px 14px;
    background: #FAFAF7;
    border: 1.5px solid #E5E3DC;
    border-radius: 10px;
    transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
    user-select: none;
  }
  .checkbox-wrap:hover {
    border-color: #C8A800;
  }
  .syc-checkbox {
    display: none;
  }
  .checkbox-box {
    width: 18px;
    height: 18px;
    min-width: 18px;
    border-radius: 5px;
    border: 1.5px solid #D4CAA0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s, border-color 0.15s;
  }
  .checkbox-wrap:has(input:checked) .checkbox-box {
    background: #C8A800;
    border-color: #C8A800;
  }
  .checkbox-wrap:has(input:checked) {
    border-color: #C8A800;
    box-shadow: 0 0 0 3px rgba(212,176,0,0.12);
    background: #FFFDE8;
  }
  .checkbox-label {
    font-size: 14px;
    color: #444;
    font-weight: 500;
}
`
;
